/* eslint-disable */
import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import { ComparisonGroup, Product, Company, Brand } from "@/models";

@Component
export default class ComparisonGroupsMixin extends Vue {
  getComparisonGroups(tag: string) {
    const url = API_ENDPOINT + `/me/comparison_groups.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  addToComparisonGroup(
    group: ComparisonGroup,
    entry: Company | Brand | Product,
    tag: string
  ) {
    const url = API_ENDPOINT + `/me/comparison_groups/${group.id}/add`;
    const data: { [key: string]: number[] } = {};

    data[entry.type] = [];
    data[entry.type].push(entry.id);

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "PUT",
      data: data,
    });
  }

  removeFromComparisonGroup(
    group: ComparisonGroup,
    entry: Company | Brand | Product,
    tag: string
  ) {
    const url = API_ENDPOINT + `/me/comparison_groups/${group.id}/remove`;
    const data: { [key: string]: number[] } = {};

    data[entry.type] = [];
    data[entry.type].push(entry.id);

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "PUT",
      data: data,
    });
  }

  createComparisonGroup(data: { name: string }, tag: string) {
    const url = API_ENDPOINT + `/me/comparison_groups.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: data,
    });
  }
}
